import {IS_SAFARI, IS_APPLE_MOBILE} from '@environment/userAgent';

let IS_WEBM_SUPPORTED: boolean;
let IS_MOV_SUPPORTED: boolean;
let IS_H265_SUPPORTED: boolean;
let IS_AV1_SUPPORTED: boolean;

if(typeof document === 'undefined') {
  IS_WEBM_SUPPORTED = !IS_SAFARI && !IS_APPLE_MOBILE;
  IS_MOV_SUPPORTED = IS_SAFARI || IS_APPLE_MOBILE;
  IS_H265_SUPPORTED = true;
  IS_AV1_SUPPORTED = !IS_SAFARI;
} else {
  const video = document.createElement('video');
  IS_WEBM_SUPPORTED = !!video.canPlayType('video/webm') && !IS_SAFARI && !IS_APPLE_MOBILE;
  IS_MOV_SUPPORTED = !!video.canPlayType('video/quicktime') || IS_SAFARI || IS_APPLE_MOBILE;
  IS_H265_SUPPORTED = !!video.canPlayType('video/mp4; codecs="hev1"');
  IS_AV1_SUPPORTED = !IS_SAFARI;
}

export {
  IS_WEBM_SUPPORTED,
  IS_MOV_SUPPORTED,
  IS_H265_SUPPORTED,
  IS_AV1_SUPPORTED
};
